import React from "react"
import { FaMinus, FaPlus, FaTrashAlt } from "react-icons/fa"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import { isDirectionLtr, thousandSeparator } from "utils"
import { deleteOrderItem, updateOrderItem } from "@redux"
import classes from "./KcOrderItem.module.scss"
import KcOrderItemSpecificationItem from "./KcOrderItemSpecificationItem"
import { languageSuffixMap } from "constant"

const KcOrderItem = (props) => {
  const { orderItem } = props

  const i18n = useTranslation()[1]

  const dispatch = useDispatch()

  const handleRemove = () => {
    dispatch(
      deleteOrderItem(
        orderItem.orderItemId
      )
    )
  }

  const handleDecrease = () => {
    const newQuantity =
      orderItem.quantity - 1

    if (newQuantity <= 0) return

    dispatch(
      updateOrderItem(
        { quantity: newQuantity },
        orderItem.orderItemId
      )
    )
  }

  const handleIncrease = () => {
    dispatch(
      updateOrderItem(
        { quantity: orderItem.quantity + 1 },
        orderItem.orderItemId
      )
    )
  }

  const totalSpecifications =
    orderItem.specificationItems.reduce((t, specificationItems) =>
      t +=
      specificationItems.salePrice *
      (specificationItems.quantity - specificationItems.freeQuantity)
      , 0
    ) * orderItem.quantity

  const total =
    totalSpecifications +
    orderItem.quantity * orderItem.salePrice

  const isLtr = isDirectionLtr(i18n.language)

  const portionItems = portion => orderItem.specificationItems.filter(item =>
    portion === "whole" ? !item.portion || item.portion === "whole" : item.portion === portion
  )
  const renderItems = items => items.map(specificationItem =>
    <KcOrderItemSpecificationItem
      key={`${specificationItem.builderStepKey || "whole"}-${specificationItem._id}`}
      orderItemQuantity={orderItem.quantity}
      specificationItem={specificationItem}
    />
  )
  const renderPortion = (faTitle, enTitle, portion) => {
    const items = portionItems(portion)
    return items.length > 0 && <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>{i18n.language === "fa" ? faTitle : enTitle}</div>
      {renderItems(items)}
    </section>
  }

  return (
    <div className={classes["card"]}>
      <div className={classes["name-container"]}>
        <LazyImage
          className={classes["image"]}
          imageWidth={100}
          quality={80}
          src={orderItem.foodImageCover}
          lazy={false}
        />

        <div
          className={clsx(
            classes["details"],
            isLtr && classes["details-ltr"]
          )}
        >
          <span className={classes["name"]}>
            {orderItem[`foodName${languageSuffixMap[i18n.language]}`]}{" "}
            {
              !orderItem.isSimple &&
              <span>
                ({orderItem[`optionName${languageSuffixMap[i18n.language]}`]})
              </span>
            }
          </span>

          {renderItems(portionItems("whole"))}
          {renderPortion("نیمه اول", "First half", "firstHalf")}
          {renderPortion("نیمه دوم", "Second half", "secondHalf")}
        </div>
      </div>

      <div className={classes["quantity"]}>
        <button
          className={classes["button"]}
          onClick={handleDecrease}
        >
          <FaMinus />
        </button>

        <b className={classes["number"]}>
          {orderItem.quantity}
        </b>

        <button
          onClick={handleIncrease}
          className={classes["button"]}
        >
          <FaPlus />
        </button>
      </div>

      <div className={classes["price"]}>
        {thousandSeparator(total)}
      </div>

      <button
        className={classes["action"]}
        onClick={handleRemove}
      >
        <FaTrashAlt
          size={25}
          color="var(--color-danger)"
        />
      </button>
    </div>
  )
}

export default KcOrderItem
